

export default {
    name: "ContentCard",
    props: {
        result: {
            type: Object,
            required: true,
            topLabel: {
                type: Object,
                required: false,
            },
            bottomLabel: {
                type: Object,
                required: false,
            },
            IconList: {
                type: Array,
                required: false,
            },
            metaData: {
                type: Object,
                required: false,
            },
            imageSrc: {
                type: String,
                required: true,
            },
            imageAlt: {
                type: String,
                required: true,
            },
            title: {
                type: String,
                required: true,
            },
            leader: {
                type: String,
                required: true,
            },
            url: {
                type: String,
                required: true,
            },
        },
        narrowCardPadding: {
            type: Boolean,
            required: false,
        }
    },
    setup(){

        return {
           
        }
    }
}